<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-10 19:18:08
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-28 16:01:30
-->
<template>
	<div class="flex-row-align-center">
		<div class="pic mt-2">
			<el-avatar shape="square" :size="52" :src="row.productPic"></el-avatar>
		</div>
		<div class="details font-h6-regular ml-8">
			<div class="flex-row-align-center">
				<div>
					<PlatformIcon :platformId="row.platform_id"></PlatformIcon>
				</div>
				<p class="yx-color-text-primary line-ellipsis-1 ml-6" style="max-width: 180px">{{ row.productName }}</p>
			</div>
			<p class="yx-color-text-regular mt-2">商品ID：{{ row.thirdProductId }}</p>
			<div class="shop-tag yx-color-text-regular mt-4">
				<img src="@/assets/public/shop-icon.png" alt="" />
				<el-tooltip class="item" effect="dark" :content="row.shopName" :disabled="isTipShopName" placement="top">
					<span>{{ row.shopName | textFormat(6) }}</span>
				</el-tooltip>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	components: {},
	mixins: [mixin],
	data() {
		return {};
	},
	computed: {
		isTipShopName({ row }) {
			let name = row.shopName;
			return name && name.length > 6 ? false : true;
		},
	},
};
</script>
<style lang="less" scoped>
.shop-tag {
	height: 18px;
	line-height: 18px;
	border-radius: 2px;
	text-align: center;
	font-size: 12px;
	margin-top: 4px;
	background-color: #f7f8fa;
	display: inline-block;
	padding: 0px 3px;
	img {
		width: 12px;
		height: 11px;
		margin-bottom: 2px;
		margin-right: 3px;
	}
}
</style>
